module.exports = __webpack_public_path__ + "img/status_5.4e518b5e.png";